import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  aboutTitle: {
    id: 'course-authoring.studio-home.sidebar.about.title',
    defaultMessage: 'New to {studioName}?',
  },
  aboutDescription: {
    id: 'course-authoring.studio-home.sidebar.about.description',
    defaultMessage: 'Click "Looking for help with Studio" at the bottom of the page to access our continually updated documentation and other {studioShortName} resources.',
  },
  studioHomeLinkToGettingStarted: {
    id: 'course-authoring.studio-home.sidebar.about.getting-started',
    defaultMessage: 'Getting started with {studioName}',
  },
  sidebarHeader2: {
    id: 'course-authoring.studio-home.sidebar.about.header-2',
    defaultMessage: 'Can I create courses in {studioName}?',
  },
  sidebarDescription2: {
    id: 'course-authoring.studio-home.sidebar.about.description-2',
    defaultMessage: 'In order to create courses in {studioName}, you must {mailTo}',
  },
  sidebarDescription2MailTo: {
    id: 'course-authoring.studio-home.sidebar.about.description-2.mail-to',
    defaultMessage: 'contact {platformName} staff to help you create a course.',
  },
  sidebarHeader3: {
    id: 'course-authoring.studio-home.sidebar.about.header-3',
    defaultMessage: 'Can I create courses in {studioName}?',
  },
  sidebarDescription3: {
    id: 'course-authoring.studio-home.sidebar.about.description-3',
    defaultMessage: 'In order to create courses in {studioName}, you must have course creator privileges to create your own course.',
  },
  sidebarHeader4: {
    id: 'course-authoring.studio-home.sidebar.about.header-4',
    defaultMessage: 'Can I create courses in {studioName}?',
  },
  sidebarDescription4: {
    id: 'course-authoring.studio-home.sidebar.about.description-4',
    defaultMessage: 'Your request to author courses in {studioName} has been denied. Please {mailTo}.',
  },
  sidebarDescription4MailTo: {
    id: 'course-authoring.studio-home.sidebar.about.description-4.mail-to',
    defaultMessage: 'contact {platformName} staff with further questions',
  },
  programsTitle: {
    id: 'course-authoring.studio-home.sidebar.programs.title',
    defaultMessage: 'About Pathways',
  },
  programsDescription: {
    id: 'course-authoring.studio-home.sidebar.programs.description',
    defaultMessage: 'Pathways are collections of courses that can be grouped together to provide a structured learning path. Use this tab to view and manage all your pathways.',
  },
  programsPlatformsTitle: {
    id: 'course-authoring.studio-home.sidebar.programs.platforms.title',
    defaultMessage: 'Platforms',
  },
  programsPlatformsDescription1: {
    id: 'course-authoring.studio-home.sidebar.programs.platforms.description-1',
    defaultMessage: 'First select a platform organization. An organization needs to have an associated platform entry created for it to be able to be assigned pathways.',
  },
  programsPlatformsDescription2: {
    id: 'course-authoring.studio-home.sidebar.programs.platforms.description-2',
    defaultMessage: 'If the organization you are trying to create a pathway for is not in the list you must create a new platform entry for that organzation.',
  },
  programsPlatformsDescription3: {
    id: 'course-authoring.studio-home.sidebar.programs.platforms.description-3',
    defaultMessage: 'It is very important that the "platform key" field matches the organization slug as defined in the enterprise app. If you need help with this reach out to the dev team!',
  },
  programsProgramsTitle: {
    id: 'course-authoring.studio-home.sidebar.programs.programs.title',
    defaultMessage: 'Pathways',
  },
  programsProgramsDescription: {
    id: 'course-authoring.studio-home.sidebar.programs.programs.description',
    defaultMessage: 'Select a pathway to view or edit from the dropdown. If the platform organization has no associated pathways the dropdown will be disabled and you must create a new pathway.',
  },
  programsCreatingTitle: {
    id: 'course-authoring.studio-home.sidebar.programs.creating.title',
    defaultMessage: 'Creating Pathways',
  },
  programsCreatingDescription1: {
    id: 'course-authoring.studio-home.sidebar.programs.creating.description-1',
    defaultMessage: 'Provide a friendly display name for the pathway you are going to create. This will be displayed to end users. All new pathways that are created are unpublished, you will need to edit the field after creation to publish a pathway.',
  },
  programsCreatingDescription2: {
    id: 'course-authoring.studio-home.sidebar.programs.creating.description-2',
    defaultMessage: 'Provide a short description of the pathway. This is user facing!',
  },
  programsCreatingDescription3: {
    id: 'course-authoring.studio-home.sidebar.programs.creating.description-3',
    defaultMessage: 'Provide metadata tags for the pathway. These are user facing! Press tab to save your entry and delete them with either the X button or backspacing into them.',
  },
  programsCreatingDescription4: {
    id: 'course-authoring.studio-home.sidebar.programs.creating.description-4',
    defaultMessage: 'Select courses to be associated with the pathway by searching in the Course List field. You can search by either course ID or by course name. Select your entry either with your mouse or by navigating with your keyboard arrow keys and hitting enter.',
  },
  programsCreatingDescription5: {
    id: 'course-authoring.studio-home.sidebar.programs.creating.description-5',
    defaultMessage: 'You can sort the courses into a specific order if you would like, the pathway will present the component courses in the order specified here.',
  },
  programsEditingTitle: {
    id: 'course-authoring.studio-home.sidebar.programs.editing.title',
    defaultMessage: 'Editing Pathways',
  },
  programsEditingDescription1: {
    id: 'course-authoring.studio-home.sidebar.programs.editing.description-1',
    defaultMessage: 'All of the fields in the view/edit view are changeable except for item_id and Associated Platform Organization. Go nuts!',
  },
  programsEditingDescription2: {
    id: 'course-authoring.studio-home.sidebar.programs.editing.description-2',
    defaultMessage: 'When you are ready to release the pathway change the Published dropdown to view and submit your edits at the bottom of the form.',
  },
  programsEditingDescription3: {
    id: 'course-authoring.studio-home.sidebar.programs.editing.description-3',
    defaultMessage: 'If you need to delete a pathway use the Delete button at the bottom. This is destructive! If you delete a pathway it is not recoverable. If you want to retire a specific pathway think about using the Published field instead.',
  },
  additionalActionsTitle: {
    id: 'course-authoring.studio-home.sidebar.additional-actions.title',
    defaultMessage: 'Additional Actions',
  },
  additionalActionsDescription: {
    id: 'course-authoring.studio-home.sidebar.additional-actions.description',
    defaultMessage: 'This section is for custom actions',
  },
  showAllActionsCheckbox: {
    id: 'course-authoring.studio-home.sidebar.additional-actions.show-all-checkbox',
    defaultMessage: 'Show all actions',
  },
  runCourseAggregationButton: {
    id: 'course-authoring.studio-home.sidebar.additional-actions.run-course-aggregation',
    defaultMessage: 'Run Course Aggregation',
  },
  taskStatusCheckerTitle: {
    id: 'course-authoring.studio-home.sidebar.task-status-checker.title',
    defaultMessage: 'Bulk Registration Task Status',
  },
  taskStatusCheckerDescription: {
    id: 'course-authoring.studio-home.sidebar.task-status-checker.description',
    defaultMessage: 'Paste a task ID from a bulk learner registration to check its progress.',
  },
  taskStatusCheckerInputPlaceholder: {
    id: 'course-authoring.studio-home.sidebar.task-status-checker.input-placeholder',
    defaultMessage: 'Paste task ID here…',
  },
  taskStatusCheckerCheckButton: {
    id: 'course-authoring.studio-home.sidebar.task-status-checker.check-button',
    defaultMessage: 'Check Status',
  },
  taskStatusCheckerPolling: {
    id: 'course-authoring.studio-home.sidebar.task-status-checker.polling',
    defaultMessage: 'Checking…',
  },
  taskStatusCheckerStopButton: {
    id: 'course-authoring.studio-home.sidebar.task-status-checker.stop-button',
    defaultMessage: 'Stop',
  },
  taskStatusCheckerClearButton: {
    id: 'course-authoring.studio-home.sidebar.task-status-checker.clear-button',
    defaultMessage: 'Clear',
  },
  taskStatusCheckerStatusLabel: {
    id: 'course-authoring.studio-home.sidebar.task-status-checker.status-label',
    defaultMessage: 'Status:',
  },
  taskStatusCheckerProgress: {
    id: 'course-authoring.studio-home.sidebar.task-status-checker.progress',
    defaultMessage: '{processed} / {total} learners processed ({percent}%)',
  },
  taskStatusCheckerProgressUnknownTotal: {
    id: 'course-authoring.studio-home.sidebar.task-status-checker.progress-unknown-total',
    defaultMessage: '{processed} learners processed ({percent}%)',
  },
  taskStatusCheckerErrorsLabel: {
    id: 'course-authoring.studio-home.sidebar.task-status-checker.errors-label',
    defaultMessage: '{count} error(s):',
  },
});

export default messages;
